import { BUDGETS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/budget_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['budgetsIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
